define(["require", "exports", "tslib", "mobx", "../constants", "../model/services/EventManager", "../utils/Environment", "../utils/JwtUtil", "../utils/LocalStorage", "../utils/TimeUtil", "./Events", "./RouteStore", "./StoreManager"], function (require, exports, tslib_1, mobx_1, constants_1, EventManager_1, Environment_1, JwtUtil_1, LocalStorage_1, TimeUtil_1, Events_1, RouteStore_1, StoreManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isUserStateGovAdminOfficer = exports.UserStore = void 0;
    class UserStore {
        logIn(token) {
            (0, EventManager_1.emitEvent)(Events_1.USER_LOGGING_IN_EVENT);
            this.token = token;
            this.user = (0, JwtUtil_1.decodeJwt)(this.token);
            (0, LocalStorage_1.setLocalStorageValue)(constants_1.USER_TOKEN, this.token);
            (0, EventManager_1.emitEvent)(Events_1.USER_LOGGED_IN_EVENT, this.user);
        }
        logOut() {
            (0, EventManager_1.emitEvent)(Events_1.USER_LOGGING_OUT_EVENT);
            this.token = null;
            this.user = null;
            (0, LocalStorage_1.setLocalStorageValue)(constants_1.USER_TOKEN, null);
            (0, EventManager_1.emitEvent)(Events_1.USER_LOGGED_OUT_EVENT);
            (0, RouteStore_1.openRoute)({ pathname: "/" });
        }
        get IsLoggedIn() {
            return this.token && !(0, JwtUtil_1.isTokenExpired)(this.token);
        }
        get User() {
            return this.user;
        }
        get Token() {
            return this.token;
        }
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "user", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "token", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            this.token = (0, LocalStorage_1.getLocalStorageValue)(constants_1.USER_TOKEN);
            this.user = this.token && (0, JwtUtil_1.decodeJwt)(this.token);
            window.addEventListener("storage", this.onStorageChange.bind(this), false);
        }
        onStorageChange(event) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if ((event === null || event === void 0 ? void 0 : event.key) == constants_1.USER_TOKEN) {
                    if (!(0, Environment_1.isProduction)()) {
                        console.log("user event", event === null || event === void 0 ? void 0 : event.key, event === null || event === void 0 ? void 0 : event.oldValue, event === null || event === void 0 ? void 0 : event.newValue);
                    }
                    const waitSeconds = 3;
                    if (event.oldValue && !event.newValue) {
                        if (!(0, Environment_1.isProduction)()) {
                            console.log("user. Logged out. Reloading..");
                        }
                        yield (0, TimeUtil_1.wait)((0, TimeUtil_1.seconds)(waitSeconds));
                        window.location.reload();
                    }
                    else if (event.newValue && event.newValue != event.oldValue) {
                        if (!(0, Environment_1.isProduction)()) {
                            console.log("user. Profile changed. Reloading..");
                        }
                        yield (0, TimeUtil_1.wait)((0, TimeUtil_1.seconds)(waitSeconds));
                        window.location.reload();
                    }
                }
            });
        }
    }
    exports.UserStore = UserStore;
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], UserStore.prototype, "user", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserStore.prototype, "token", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UserStore.prototype, "logIn", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserStore.prototype, "logOut", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserStore.prototype, "IsLoggedIn", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserStore.prototype, "User", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserStore.prototype, "Token", null);
    function isUserStateGovAdminOfficer() {
        var _a, _b;
        const userStore = StoreManager_1.StoreManager.Instance.userStore;
        return userStore.IsLoggedIn && !!((_b = (_a = userStore.User) === null || _a === void 0 ? void 0 : _a.roles) === null || _b === void 0 ? void 0 : _b.find(x => x.toLowerCase() == "admin" || x.toLowerCase().indexOf("CN=StateGovAdminUsers,".toLowerCase()) > -1));
    }
    exports.isUserStateGovAdminOfficer = isUserStateGovAdminOfficer;
});
